export var AssessmentStatus;
(function (AssessmentStatus) {
    AssessmentStatus["Complete"] = "complete";
    AssessmentStatus["InProgress"] = "inprogress";
    AssessmentStatus["NotStarted"] = "notstarted";
})(AssessmentStatus || (AssessmentStatus = {}));
//# sourceMappingURL=assessment-status.js.map